module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_10X_WTA.7df7a501.png";